export const roles = [
  { id: 0, name: '管理员' },
  { id: 1, name: '普通用户' },
  { id: 2, name: '销售' }
]

export const roleMap = roles.reduce((acc, role) => {
  acc[role.id] = role
  return acc
}, {})

export const states = [
  { id: 0, name: '初始', type: 'warning' },
  { id: 1, name: '正常', type: 'primary' },
  { id: 2, name: '已锁定', type: 'danger' }
]

export const stateMap = states.reduce((acc, state) => {
  acc[state.id] = state
  return acc
}, {})

export default {
  roles,
  roleMap,
  states,
  stateMap
}
